import script from "./Auditorio.vue?vue&type=script&setup=true&lang=js"
export * from "./Auditorio.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader});
